const project = (key, items) => {
  const all = items.map(item => item[key]);
  const byId = items.reduce(
    (acc, item) => ({
      ...acc,
      [item[key]]: item
    }),
    {}
  );
  return { byId, all };
};

export const projectById = items => project("id", items);

export const projectByCode = items => project("code", items);



// WEBPACK FOOTER //
// ./src/services/project.js